var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
        ],
        staticClass: "mt-3",
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: { s: 2, l: 2 },
                expression: "{s:2, l:2}",
              },
            ],
          },
          [_vm._v(" " + _vm._s(_vm.$t("info.viaTrip")) + ": ")]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: { s: 1, l: 1 },
                expression: "{s:1, l:1}",
              },
            ],
          },
          [_vm._v(" " + _vm._s(_vm.$t("no")) + " ")]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: { s: 1, l: 1 },
                expression: "{s:1, l:1}",
              },
            ],
          },
          [
            _c("pui-toggle", {
              key: _vm.toggleFlag,
              attrs: { checked: _vm.currentState.isViaTrip },
              on: {
                change: function ($event) {
                  return _vm.toggleIsViaTrip(
                    _vm.currentVgbSelection.enumVgbTimeframeSid
                  )
                },
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: { s: 1, l: 1 },
                expression: "{s:1, l:1}",
              },
            ],
          },
          [_vm._v(" " + _vm._s(_vm.$t("yes")) + " ")]
        ),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
        ],
        staticClass: "mt-2",
      },
      [
        _c(
          "pui-form-group",
          {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: { s: 12, l: 12 },
                expression: "{s:12, l:12}",
              },
            ],
            attrs: { label: _vm.$t("info.eventDescription") },
          },
          [
            _c("pui-form-textarea", {
              attrs: {
                placeholder: "",
                "max-length": _vm.maxInputLength,
                grow: true,
                "is-disabled": _vm.isReadOnly,
                "is-valid": _vm.isEventDescriptionValid,
              },
              model: {
                value: _vm.currentState.eventDescription,
                callback: function ($$v) {
                  _vm.$set(_vm.currentState, "eventDescription", $$v)
                },
                expression: "currentState.eventDescription",
              },
            }),
            _c("div", { staticStyle: { "text-align": "right" } }, [
              _vm._v(
                " " +
                  _vm._s(_vm.currentState.eventDescription.length) +
                  " / " +
                  _vm._s(_vm.maxInputLength) +
                  " "
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
        ],
      },
      [
        _c(
          "pui-form-group",
          {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: { s: 12, l: 12 },
                expression: "{s:12, l:12}",
              },
            ],
            attrs: { label: _vm.$t("info.rootCauseAnalysis") },
          },
          [
            _c("pui-form-textarea", {
              attrs: {
                placeholder: "",
                "max-length": _vm.maxInputLength,
                grow: true,
                "is-disabled": _vm.isReadOnly,
              },
              model: {
                value: _vm.currentState.rootCauseAnalysis,
                callback: function ($$v) {
                  _vm.$set(_vm.currentState, "rootCauseAnalysis", $$v)
                },
                expression: "currentState.rootCauseAnalysis",
              },
            }),
            _c("div", { staticStyle: { "text-align": "right" } }, [
              _vm._v(
                " " +
                  _vm._s(_vm.currentState.rootCauseAnalysis.length) +
                  " / " +
                  _vm._s(_vm.maxInputLength) +
                  " "
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
        ],
      },
      [
        _c(
          "pui-form-group",
          {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: { s: 12, l: 12 },
                expression: "{s:12, l:12}",
              },
            ],
            attrs: { label: _vm.$t("info.reviewAndFollowUp") },
          },
          [
            _c("pui-form-textarea", {
              attrs: {
                placeholder: "",
                "max-length": _vm.maxInputLength,
                grow: true,
                "is-disabled": _vm.isReadOnly,
              },
              model: {
                value: _vm.currentState.reviewFollowUp,
                callback: function ($$v) {
                  _vm.$set(_vm.currentState, "reviewFollowUp", $$v)
                },
                expression: "currentState.reviewFollowUp",
              },
            }),
            _c("div", { staticStyle: { "text-align": "right" } }, [
              _vm._v(
                " " +
                  _vm._s(_vm.currentState.reviewFollowUp.length) +
                  " / " +
                  _vm._s(_vm.maxInputLength) +
                  " "
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
        ],
      },
      [
        _c(
          "pui-form-group",
          {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: { s: 12, l: 12 },
                expression: "{s:12, l:12}",
              },
            ],
            attrs: { label: _vm.$t("info.preventiveMeasure") },
          },
          [
            _c("pui-form-textarea", {
              attrs: {
                placeholder: "",
                "max-length": _vm.maxInputLength,
                grow: true,
                "is-disabled": _vm.isReadOnly,
              },
              model: {
                value: _vm.currentState.preventativeMeasure,
                callback: function ($$v) {
                  _vm.$set(_vm.currentState, "preventativeMeasure", $$v)
                },
                expression: "currentState.preventativeMeasure",
              },
            }),
            _c("div", { staticStyle: { "text-align": "right" } }, [
              _vm._v(
                " " +
                  _vm._s(_vm.currentState.preventativeMeasure.length) +
                  " / " +
                  _vm._s(_vm.maxInputLength) +
                  " "
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      [
        _c("pui-lightbox", {
          ref: "forbiddenChoicePopupRef",
          attrs: {
            "default-header-label": _vm.$t("forbidden"),
            "default-trigger-label": "",
            "show-lightbox-close-icon": false,
            "fit-content": true,
            fullscreen: false,
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function () {
                return [
                  _c("div", { staticClass: "mt-3 mb-3" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("additionalInfoForbidden")) + ". "
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "lightbox-footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                          value: { s: 12, l: 3 },
                          expression: "{ s: 12, l: 3 }",
                        },
                      ],
                    },
                    [
                      _c(
                        "pui-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.closePopup()
                            },
                          },
                        },
                        [_vm._v(" OK ")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }